import {SmartComponent} from "smart-component-js";
import IconManager from "../utils/IconManager";
import Utility from "../../common/Utility";

class DefaultCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.el = element;
        this.init();
    }

    addShowPasswordButton() {
        const passwordInputs = document.querySelectorAll('input[type="password"]');
        passwordInputs.forEach((input) => {
            const wrapper = input.parentElement;
            wrapper.insertAdjacentHTML('beforeend', '<button type="button" class="visibility-icon"></button>');
            this.addPasswordListener(wrapper, input);
        });
    }


    smoothAnchorScroll() {
        document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const hrefAttribute = this.getAttribute('href')?.replace('#', '');
                const element = document.getElementById(hrefAttribute) || document.querySelector(`[data-anchor="${hrefAttribute}"]`);
                element?.scrollIntoView({behavior: 'smooth'});
            });
        });
    }


    checkRegSrc() {
        let regSrc = Utility.getUrlParameter("reg-src");
        if(!regSrc) return;
        document.body.classList.add('fixed-loading');
        this.addLogoutIframe(regSrc);
    }

    addLogoutIframe(regSrc) {
        try {
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = '/user/logout';
            document.body.appendChild(iframe);

            setTimeout(() => {
                window.location.href = `/lp/${regSrc}`;
            }, 3000);
        } catch (e) {
            document.body.classList.remove('fixed-loading');
        }
    }


    addLoginListener() {
        const buttons = document.querySelectorAll('.gigya-login-button');
        buttons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                window.location.href = `${GENERIC_TRANSLATIONS.loginLink}?urlBack=${encodeURIComponent(location.href)}&regSource=${encodeURIComponent(location.href)}`;
            })
        });
    }


    addPasswordListener(wrapper, input) {
        wrapper.querySelector('.visibility-icon').addEventListener('click', () => {
            const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
            input.setAttribute('type', type);
            wrapper.classList.toggle('password-visible');
        });
    }

    init() {
        window.iconManager = new IconManager();
        this.loadChildComponents(this);
        this.smoothAnchorScroll();
        this.addLoginListener();
        this.checkRegSrc();

        document.addEventListener("yxp-form-loaded", () => {
            this.loadChildComponents(this);
            this.addShowPasswordButton();
        });
    }
}

export default DefaultCtrl;
